export const USER_ACCESS = 'USER_ACCESS';

export const setUserAccess = roleAccess => dispatch => {
    dispatch({
        type: USER_ACCESS,
        roleAccess: roleAccess
    });
};
